module.exports = __webpack_public_path__ + "static/media/inspectionSelectedDvir.84a3c4f6.svg";